import { useLingui } from "@lingui/react";

import { Language } from "@/generated/languages";

const useLanguage = (): Language => {
  const { i18n } = useLingui();
  return i18n.locale as Language;
};

export { useLanguage };
